import equalByNameAndPaymentParamId from '../../utils/equalByNameAndPaymentParamId';
import {i18n} from "../../../vue-i18n";

export default class SetIndexation {
  constructor(paymentParametersId, newIndexation, currentIndexationName) {
    this.commandName = "SetIndexation";

    this.paymentParametersId = paymentParametersId;
    this.newIndexation = newIndexation;

    let date = this.newIndexation.firstIndexationDateDay !== null ? ` ${i18n.t('CONTENT.from')} ${this.newIndexation.firstIndexationDateDay}.${this.newIndexation.firstIndexationDateMonth}.${this.newIndexation.firstIndexationDateYear}` : '';

    let percent = this.newIndexation.indexationPercent !== null ? ` - ${this.newIndexation.indexationPercent}%` : '';

    this.description =
      `${currentIndexationName}${date}${percent}`
  }

  // Use this method to push this command to the server
  serialize() {
    return {
      commandName: this.commandName,
      serialisedCommand: JSON.stringify({
        PaymentParametersId: this.paymentParametersId,
        NewIndexation: this.newIndexation
      })
    }
  }

  equal = (other) => equalByNameAndPaymentParamId(this, other);
}
